module.exports = __webpack_public_path__ + "img/imgSrc4.e8c9a261.png";